<template>
  <ion-page>
    <ion-header>
      <ion-toolbar lines="none" translucent class="menu-toolbar">
        <ion-buttons slot="end" @click="goPrev()">
          <div class="pl-05">
            <ion-icon :icon="closeOutline" size="large" />
          </div>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="menu-content" v-if="team">
      <div class="d-flex gap-10 align-items-center pl-20">
        <div class="d-flex gap-10 align-items-center">
          <TeamLogo :large="true" :team="team" />
          <div class="d-flex flex-column">
            <h1 class="c-white">{{ team?.name }}</h1>
            <span class="c-gray">{{ team?.orgtree && team?.orgtree?.club ? team?.orgtree?.club?.name : '' }}</span>
          </div>
        </div>
      </div>
      <div class="c-white pl-10 mt-10 filter-season">
        <ion-item>
          <ion-label>Filter Season</ion-label>
          <ion-select placeholder="Select One" v-model="filterSeason" @ionChange="filterSeasonChange">
            <ion-select-option v-for="filSeason in filterSeasons" :key="filSeason" :value="filSeason">{{ filSeason }}</ion-select-option>
          </ion-select>
        </ion-item>
      </div>

      <ion-grid :scroll-x="true" class="option-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
        <ion-chip v-for="option in submenu" :key="option" @click="currentOption = option" :class="{
          'mt-20': true,
          chip: true,
          active: option === currentOption,
          selectable: option !== currentOption
        }">
          <ion-label >{{ option }}</ion-label>
        </ion-chip>
      </ion-grid>

      <section class="overview-section" v-if="currentOption === 'Overview' ">
        <div class="overview mt-20">
          <div class="overview-line">
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesPlayed }} </p>
              <p class="c-gray">Matches Played</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesWon }} </p>
              <p class="c-gray">Matches Won</p>
            </div>
            <div class="overview-box">
              <p class="f-bold c-white"> {{ matchesLost }} </p>
              <p class="c-gray">Matches Lost</p>
            </div>
          </div>
        </div>

        <div class="recent-match" v-if="Object.keys(latestMatch).length">
          <h2 class="c-white pl-20">Most Recent Match</h2>
          <match-card :match="latestMatch" :key="latestMatch._id" />
        </div>

        <div class="line-up p-10" v-if="!hideTeamList">
          <h2 class="c-white pl-10">Line Up</h2>
          <!-- ion list -->
          <ion-list lines="none">
            <ion-item lines="none" v-for="player in memberDetailsSeasonFiltered" :key="player._id" @click="get(player, 'isPublic', true) ? goPlayer(player._id) : null">
              <ion-avatar slot="start">
                <img :src="player.meta && get(player, 'isPublic', true) && presentation.showLogo && player.meta.imgUrl ? player.meta.imgUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt9KcSYpVsC4b1o_3v2QgaIyo3NxOk6v9eoQ&usqp=CAU'" />
              </ion-avatar>
              <ion-label>
                <h3 class="c-white">{{ get(player, 'isPublic', true) ? player.profile.firstName + ' ' + player.profile.lastName : 'Player' }}</h3>
                <p class="c-gray">{{ player.position }}</p>
              </ion-label>
              <!-- tag player type at end -->
              <ion-badge class="badge" slot="end" color="danger" v-if="checkHasExemptionImport(player)">Im</ion-badge>
              <ion-badge class="badge" slot="end" color="danger" v-if="checkHasExemptionDispensation(player)">D</ion-badge>
              <ion-badge class="c-white" slot="end">{{ getPlayerType(player._id) }}</ion-badge>
            </ion-item>
          </ion-list>
        </div>

        <div v-else class="p-10 line-up d-flex flex-column align-items-center justify-content-center">
          <h2 class="c-white pl-10">Line Up</h2>
          <p class="c-white">Team List is hidden or not yet submitted for this team</p>
        </div>
      </section>

      <section class="matches mt-10" v-if="currentOption === 'Matches' ">
        <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="competitions.length">
            <!-- <ion-label>Leaderboard Type</ion-label> -->
            <ion-select v-model="compFilter">
              <ion-select-option v-for="{ _id, name } in competitions" :value="_id" :key="_id">{{ name }}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item lines="none">
            <!-- <ion-label>Leaderboard Type</ion-label> -->
            <ion-select v-model="matchType" interface="popover">
              <ion-select-option v-for="type in ['Completed', 'Upcoming']" :key="type" :value="type">{{ type  }}</ion-select-option>
            </ion-select>
          </ion-item>

        </div>
        <div class="competition" v-for="{ compId, matches } in groupedByComp" :key="`comp-${compId}`">
          <div v-if="matches.length && compId === compFilter">
            <!-- <h2 class="c-white pl-20">{{ name }}</h2> -->
            <match-card :match="match" v-for="match in matches" :key="match._id" class="mb-1" />
          </div>
        </div>
      </section>

      <section class="matches mt-10 p-10" v-if="currentOption === 'Season Summary' ">
        <!-- Performance Summary -->
        <h2 class="c-white pl-10 mb-1">Performance By Season</h2>
        <ion-grid :scroll-x="true" class="appearance-row ml-10 mr-10 " style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
          <div class="season-stat-header" :style="styleGridTemplateColumns(`3rem 3rem`, filteredEvents.length)">
            <span class="season"></span>
            <span class="matches-played"> P </span>
            <span class="stat" v-for="stat in filteredEvents" :key="`${stat}`"> {{ abbreviate(stat) }}</span>
          </div>
          <ion-list lines="none" class="performance-by-season">
            <div class="season-stat" :style="styleGridTemplateColumns(`3rem 3rem`, generateStat(row.matches).length)" v-for="row in statBySeason" :key="row._id">
              <span class="season c-gray"> {{ row.season }} </span>
              <span class="matches-played"> {{ row.matches.length }} </span>
              <span class="stat" v-for="stat in generateStat(row.matches)" :key="`${stat}-${row._id}`"> {{ this.getVal(stat, generateStat(row.matches)) }}</span>
            </div>
          </ion-list>
        </ion-grid>

        <!-- Stats -->
        <h2 class="c-white pl-10 mt-30">Appearances</h2>
        <!-- <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="seasons.length">
            <ion-select v-model="seasonFilter" placeholder="Filter by Season">
              <ion-select-option v-for="season in seasons" :value="season" :key="season">{{ season }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div> -->
        <div class="d-flex flex-column pl-10">
          <ion-item lines="none" v-if="competitions.length">
            <ion-select interface="action-sheet" v-model="compFilter" placeholder="Filter by Competition">
              <ion-select-option v-for="{ _id, name } in competitions" :value="_id" :key="_id">{{ name }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>

        <ion-grid :scroll-x="true" class="appearance-row ml-10 mr-10 mt-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap v-if="filteredMatches && filteredMatches.length">
          <div :style="styleGridTemplateColumns(`3.5rem 9.5rem 3rem`, filteredEvents.length)" :class="{'appearance-stat-header': true }">
            <span class="date c-gray"> Rnd </span>
            <span class="date c-gray"> Vs </span>
            <span class="date c-gray"> Result </span>
            <span class="date c-gray"
              v-for="stat in filteredEvents"
              :key="stat?.name"> {{ abbreviate(stat) }}</span>
          </div>
          <div :style="styleGridTemplateColumns(`3rem 9.5rem 3rem`, generateStat([row]).length)" :class="{'appearance-stat': true, 'won': heroWon(row), 'lost': heroLost(row) }" v-for="row in filteredMatches" :key="row._id">
              <span class="date c-gray"> {{ row.round?.name || row.round?.number }} </span>
              <div class="d-flex gap-05">
                <span class="f-bold"> {{ [get(row, 'homeTeam.name', 'N/A'), get(row, 'awayTeam.name', 'N/A')].find(t => t !== team?.name) }} </span>
              </div>
              <span class="c-gray d-flex"> {{ row.scores.homeTeam }} : {{ row.scores.awayTeam }} </span>
              <div class="d-flex flex-column" v-for="stat in generateStat([row])" :key="`${stat}-${row._id}`">
                <span class="stat-value c-white">
                  {{ getVal(stat, generateStat([row])) }}
                </span>
              </div>
          </div>
        </ion-grid>

        <div class="option-row d-flex justify-center mt-20" v-else>
          <p class="c-white">
            No matches availble for this season.
          </p>
        </div>

        <ion-list lines="none" class="mt-20 match-stat-section">

        </ion-list>

      </section>


    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
// import { loadingController, menuController } from "@ionic/vue";
import TeamLogo from '../matches/base/team-logo.vue'
import _ from 'lodash';
import moment from 'moment';
import MatchCard from '../../components/MatchCard.vue'
import { mapGetters } from 'vuex';

export default {
  components: {
    TeamLogo,
    MatchCard
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    const d = new Date();
    return {
      team: false,
      matches: [],
      key: 1,
      submenu: [
        'Overview',
        'Matches',
        'Season Summary',
      ],
      matchType: 'Completed',
      currentOption: 'Overview',
      compFilter: false,
      seasonFilter: false,
      get: _.get,
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      filterSeason: 'All',
      scoringEvents: [],
      playerMovements: [],
    };
  },
  async mounted() {
    console.log('In Team Details Page')
    const d = new Date();
    try {
      this.$store.dispatch('national/setup');
      const teamId = this.$route.params.id;
      const resTeam = await this.$http.get(`/assemble/api/v1/live/teams/${teamId}`);
      if (!resTeam.data || !resTeam.data.data) {
        this.$router.push('/teams');
        return;
      }
      this.team = resTeam.data.data.team[0];
      this.hideTeamList = resTeam.data.data.isHideTeamList;
      // this.$store.commit('national/setEntity', this.team);
      this.matches = resTeam.data.data.matches;
      this.seasonFilter = _.get(this.matches[0], 'season');
      this.compFilter = this.matches[0] ? _.get(this.matches[0], 'competition._id') : false;
      // add to top of recently viewed local storage, type team, maximum 3 items
      const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      const newRecentlyViewed = [
        { type: 'team', entity: this.team },
        ...recentlyViewed.filter(item => item.entity._id !== this.team._id)
      ].slice(0, 5);
      localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewed));
      this.getEventsByTeamComps();
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  computed: {
    // ...mapGetters('national', ['scoringEvents', 'playerMovements']),
    entity() {
      return this.$store.getters['national/entity'];
    },
    presentation() {
      return this.$store.getters['national/presentation'];
    },
    filterSeasons() {
      const teamSeason = _.get(this.team, 'season');
      const uniqueSeasons = _.uniq(_.map(this.matches, 'season'));
      const allSeasons = _.sortedUniq(_.compact(_.uniq([teamSeason, ...uniqueSeasons])));
      allSeasons.push('All');
      return allSeasons;
    },
    filteredEvents() {
      const events = this.scoringEvents.concat(this.playerMovements).filter(e => e.visibleInLadders || e.visibleInLadders === undefined);
      if([8, 12].includes(this.nationalId)) {
        return this.reOrderEvent(events);
      }
      return events;
    },
    latestMatch() {
      // latest match with status final in the past
      let latestMatch = _.filter(this.filterSeasonMatches, match => {
        return moment(match.dateTime).isBefore(moment()) && match.status !== 'pre-game';
      });
      console.log('latestMatchs', latestMatch);
      latestMatch = _.orderBy(latestMatch, ['dateTime'], ['desc']);
      latestMatch = _.get(latestMatch, '[0]', {});
      console.log('latestMatch', latestMatch);
      return latestMatch;
    },
    memberDetailsSeasonFiltered() {
      const memberDetails = _.get(this.team, 'memberDetails', []);
      if (this.filterSeason === 'All') return memberDetails;
      const members = _.get(this.team, 'members', []).concat(_.get(this.team, 'eventMembers', [])).filter((current, index, self) => self.findIndex(t => t._id === current._id) === index);
      const seasonMembers = _.filter(members, member => member.season === this.filterSeason);
      const mappedSeasonMembersId = _.map(seasonMembers, '_id');
      const memberDetailsByMapped = _.filter(memberDetails, member => _.includes(mappedSeasonMembersId, _.get(member, '_id')));
      return memberDetailsByMapped;
    },
    filteredMatches() {
      let matches = this.filterSeasonMatches;
      console.log('matches at filteredMatches before filter', matches);
      matches = _.filter(matches, m => !m.meta.isBye)
      matches = _.orderBy(matches, ['round.number'], ['asc']);
      console.log('matches at filteredMatches', matches);

      let filtered = [];
      if (this.compFilter) {
        filtered = matches.filter(match => _.get(match, 'competition._id') === this.compFilter);
      }
      if (this.filterSeason !== 'All') {
        filtered = filtered.filter(match => match.season === this.filterSeason);
      }

      filtered = filtered.filter((match) => {
        const hideRounds = _.get(match, 'competition.display.hideRounds', []);
        const matchDateTime = moment(match.dateTime).valueOf();
        const isInHideRounds = hideRounds.some(hideRound => matchDateTime >= hideRound.from && matchDateTime <= hideRound.to);
        return !isInHideRounds;
      });

      return filtered.sort((a, b) => a.round.number - b.round.number);
    },
    matchesPlayed() {
      const matches = this.filterSeasonMatches;
      return matches.filter(match => match.status === 'final').length;
    },
    matchesWon() {
      const matches = this.filterSeasonMatches;
      const teamId = +this.$route.params.id;
      return matches
        .filter(match => {
          const isHomeTeam = _.get(match, 'homeTeam._id') === teamId;
          return match.status === 'final'
            && (isHomeTeam
              ? match.scores.homeTeam > match.scores.awayTeam
              : match.scores.awayTeam > match.scores.homeTeam
            );
        })
        .length
    },
    matchesLost() {
      const matches = this.filterSeasonMatches;
      const teamId = +this.$route.params.id;
      return matches
        .filter(match => {
          const isHomeTeam = _.get(match, 'homeTeam._id') === teamId;
          return match.status === 'final'
            && (isHomeTeam
              ? match.scores.homeTeam < match.scores.awayTeam
              : match.scores.awayTeam < match.scores.homeTeam
            );
        })
        .length
    },
    statBySeason() {
      const { seasons, matches: allMatches } = this;
      return seasons.reduce((acc, season) => {
        const matches = allMatches.filter(match => match.season === season);
        const stats = this.generateStat(matches);
        acc.push({ season, stats, matches });
        return acc;
      }, []);
    },
    filterSeasonMatches() {
      const { filterSeason, matches } = this;
      if (filterSeason === 'All') return matches;
      return matches.filter(match => match.season === filterSeason);
    },
    groupedByComp() {
      let { matchType } = this;
      let matches = this.filterSeasonMatches;
      matches = _.filter(matches, m => !m.meta.isBye)
      if (!matches) return [];
      const compIds = _.uniq(matches.map(match => _.get(match, 'competition._id')));
      let result = compIds.map(compId => {
        const competition = _.get(matches.find(m => _.get(m, 'competition._id') === compId), 'competition');
        if (!competition) return false;
        const compName = _.get(competition, 'name');
        if (_.get(competition, 'display.hideRounds', []).length && matches && matches.length) {
          matches = matches.filter((match) => {
            const hideRounds = _.get(competition, 'display.hideRounds');
            const matchDateTime = moment(match.dateTime).valueOf();
            const isInHideRounds = hideRounds.some(hideRound => matchDateTime >= hideRound.from && matchDateTime <= hideRound.to);
            return !isInHideRounds;
          });
        }
        return {
          compId,
          name: compName,
          matches: matches
            .filter(match => _.get(match, 'competition._id') === compId)
            .filter(match => {
              if (matchType === 'Completed') {
                return match.status === 'final' || moment(match.dateTime).isBefore(moment());
              }
              return moment(match.dateTime).isAfter(moment());
            })
            .sort((a, b) => {
              // Sort by date - ascending for upcoming matches, descending for completed
              const dateA = moment(a.dateTime).valueOf();
              const dateB = moment(b.dateTime).valueOf();
              return matchType === 'Completed' ? dateB - dateA : dateA - dateB;
            })
        }
      });
      result = _.filter (result, r => r);
      return result;
    },
    competitions() {
      return this.getCompetitionsFromMatches();
    },
    seasons() {
      return this.matches.map(match => match.season).filter((name, index, arr) => arr.indexOf(name) === index);
    },
  },
  methods: {
    getCompetitionsFromMatches() {
      const uniq = this.matches.map(match => _.get(match, 'competition.name')).filter((name, index, arr) => arr.indexOf(name) === index);
      const result = uniq.map(name => _.get(this.matches.find(match => _.get(match, 'competition.name') === name), 'competition'));
      let filtered = result;
      if (this.filterSeason !== 'All') {
        filtered = _.filter(result, comp => {
          return comp.season === this.filterSeason;
        });
      }
      return filtered;
    },
    async getEventsByTeamComps() {
      const competitions = this.getCompetitionsFromMatches();
      const mappedCompIds = _.map(competitions, '_id');
      const competitionIds = _.filter(mappedCompIds, (c) => c);
      // [POST] assemble/api/v1/live/competitions/events
      const resCompEvents = await this.$http.post('/assemble/api/v1/live/competitions/events', { competitionIds });
      const scoringEvents = _.get(resCompEvents, 'data.data.allEventsCombined.scoringEvents', []);
      const playerMovements = _.get(resCompEvents, 'data.data.allEventsCombined.playerMovements', []);
      this.scoringEvents = scoringEvents;
      this.playerMovements = playerMovements;
    },
    checkHasExemptionImport(member) {
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), { type: 'import', flag: true });
    },
    checkHasExemptionDispensation(member) {
      const exemptionList = _.get(member, 'meta.exemptionList', []);
      return _.find((exemptionList), { type: 'dispensation', flag: true });
    },
    filterSeasonChange() {
      this.compFilter = _.get(this.competitions[0], '_id');
    },
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    },
    reOrderEvent(events) {
      // G PG YC, 2M, RC and BC
      return [events[0], events[1], events[3], events[5], events[2], events[4]];
    },
    getVal(stat, matches) {
      if ((this.nationalId === 8 || this.nationalId === 12) && stat.eventName === 'Goal') {
        const getPG = matches.find((m) => m.eventName === 'Penalty Goal');

        return stat.total + getPG.total;
      }

      return stat.total;
    },
    abbreviate(stat) {
      if (stat.abbreviation) return stat.abbreviation;
      return stat?.name?.split(' ').map(s => s.charAt(0)).join('');
    },
    getPlayerType(id) {
      const { members } = this.team;
      const player = _.find(members, { _id: id });
      return _.get(player, 'memberType', '').toUpperCase();
    },
    goPrev() {
      this.$router.go(-1);
    },
    goPlayer(playerId) {
      if(this.entity && this.entityLevel && this.entityName){
        this.$router.push(`/c/${this.entityLevel}/${this.entityName}/players/${playerId}`);
        return;
      }
      this.$router.push(`/players/${playerId}`);
    },
    heroWon(row) {
      const isHomeTeam = +this.$route.params.id === _.get(row, 'homeTeam._id');
      if (isHomeTeam) return row.scores.homeTeam > row.scores.awayTeam;
      return row.scores.awayTeam > row.scores.homeTeam;
    },
    heroLost(row) {
      const isHomeTeam = +this.$route.params.id === _.get(row, 'homeTeam._id');
      if (isHomeTeam) return row.scores.homeTeam < row.scores.awayTeam;
      return row.scores.awayTeam < row.scores.homeTeam;
    },
    generateStat(matches) {
      const { scoringEvents, playerMovements } = this;
      const scorings = scoringEvents
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = matches.reduce((ac, match) => {
            const { scoringEvents } = match;
            const eventTotal = scoringEvents.filter(e => e.type === type).length
            return ac + eventTotal;
          }, 0);
          return acc.concat({ type, total, eventName });
        }, [])
      const movements = playerMovements
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, movement) => {
          const { type, name: movementName } = movement;
          const total = matches.reduce((ac, match) => {
            const { playerMovements } = match;
            const movementTotal = playerMovements.filter(e => e.type === type).length
            return ac + movementTotal;
          }, 0);
          return acc.concat({ type, total, movementName });
        }, [])

      const stats = scorings.concat(movements);
      if([8, 12].includes(this.nationalId)) {
        // G PG YC, 2M, RC and BC
        return this.reOrderEvent(stats);
      }
      return stats;

    },
  },
  watch:{
    currentOption:{
      handler: function(val){
        if( val=== 'Season Summary'){
          const numberOfEvents = this.filteredEvents.length;
          setTimeout(() => {
            const elementsAppearanceHeader = document.getElementsByClassName('appearance-stat-header');
            const elementsStatsHeader = document.getElementsByClassName('season-stat-header');
            const elementsAppearanceValue = document.getElementsByClassName('appearance-stat');
            const elementsStatsValue = document.getElementsByClassName('season-stat');
            const elementsAppearanceValueArray = Array.from(elementsAppearanceValue);
            const elementsStatsValueArray = Array.from(elementsStatsValue);


            if((elementsAppearanceHeader && elementsAppearanceValue) || (elementsStatsHeader && elementsStatsValue)) {
              elementsAppearanceHeader[0].style.gridTemplateColumns = `2rem 9.5rem 4rem repeat(${numberOfEvents}, 2.5rem)`;
              elementsStatsHeader[0].style.gridTemplateColumns = `2rem 9.5rem 4rem repeat(${numberOfEvents}, 2.5rem)`;
              elementsAppearanceValueArray.forEach(
                (element) => {
                  element.setAttribute('style', `grid-template-columns: 2rem 9.5rem 4rem repeat(${numberOfEvents}, 2.5rem) !important`);
                }
              );
              elementsStatsValueArray.forEach(
                (element) => {
                  element.setAttribute('style', `grid-template-columns: 2rem 9.5rem 4rem repeat(${numberOfEvents}, 2.5rem) !important`);
                }
              );

            }
          }, 100);
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

/* Set the width to the full container and center the content */
ion-select {
  width: 100%;

  // justify-content: center;
}

h1, h2, h3 {
  font-family: 'Cairo';
  // margin: 0;
}

.season-stat-header {
  display: grid;
  gap: 0.5rem;
  // grid-template-columns: 3rem 3rem repeat(auto-fill, 2.5rem);
  // background: #1d1f22;
  // border-radius: 14px;
  padding: 0.5rem 1rem;
  // margin-bottom: 1.5rem;
  // margin-bottom: 0.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
  text-overflow: clip;
}

.season-stat {
  display: grid;
  gap: 0.5rem;
  // grid-template-columns: 3rem 3rem repeat(auto-fill, 2.5rem);
  background: #1d1f22;
  padding: 0.5rem 1rem;
  // border-radius: 14px;
  // padding: 10px;
  // margin-bottom: 1rem;
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  // text-align: center;
  color: #fff;
  // grid-template-columns: ;
  text-overflow: clip;
}

.overview {
  padding: 1rem;
  .overview-line {
    display: flex;
    justify-content: space-between;
    @media screen and (min-width: 768px) {
      justify-content: start;
    }

    gap: 1rem;
    .overview-box {
      border-radius: 12px;
      padding: 1rem 1.5rem;
      background: #1e1f22;
      display: flex;
      flex-direction: column;
      // align-items: center;
      p { margin: 0; }
      .f-bold {
        font-size: 1.5rem;
        font-weight: bold;
      }

      .c-gray {
        font-size: 0.8rem;
      }
    }
  }
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.appearance-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: 1rem;
  background: #1e1f22 !important;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: 'Cairo';
  &.active {
    background: var(--highlight-color);
    ion-label {
      color: #000;
    }
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}

ion-badge {
  white-space: break-spaces;
}

.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
  box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.appearance-stat-header {
  display: grid;
  gap: 0.5rem;
  // background: #1d1f22;
  // border-radius: 14px;
  padding: 0.5rem 1.5rem;
  margin: 0 0 1rem 0;
  // margin-bottom: 0.5rem;
  color: #a9a9a9;
  font-size: 0.8rem;
  font-weight: bold;
}

.appearance-stat {
  position: relative;

  &.won::after {
    // green line at start
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 95%;
    background: #00c853;
    // border-radius: 14px;
    z-index: 10;
  }

  &.lost::after {
    // red line at start
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 90%;
    background: #ff5252;
    // border-radius: 14px;
    z-index: 10;
  }

  ::after {
    clip-path: polygon(0% 0%, 49% 0, 49% 82%, 0 100%, 0% 100%);

    content: '';
    position: absolute;
    top: 0;
    left: 0.25rem;
    width: 0.5rem;
    height: 90%;
    background: #656866;
    // border-radius: 14px;
    z-index: 10;
  }

  display: grid;
  gap: 0.5rem;
  // background: #1d1f22;
  padding: 1rem 1.5rem;
  // border-radius: 14px;
  // padding: 10px;
  // margin-bottom: 1rem;
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  // width: 100%;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: .7rem;
  line-height: 1rem;
  // text-align: center;
  color: #fff;
  // grid-template-columns: ;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.filter-season {
  width: 25rem;
}

.badge {
  // background: #c52828;
  background: #c52828;
  padding: 0.2rem 0.8rem;
  padding-top: 0.3rem;
  border-radius: 25%;
  font-size: small;
  margin-right: 10px;
}

</style>
